import {
  ProposalDetail as APIProposalDetails,
  Participant,
  StyleGuide,
} from "api/Api";

export interface ProposalDetails {
  id: string;
  rfpId: string;
  isPublished: boolean;
  orgId: string;
  participants: Participant[];
  instructions: string;
  styleGuide: StyleGuide;
}

export function proposalDetialsFromApi(
  id: string,
  data: APIProposalDetails
): ProposalDetails {
  const styleGuide: StyleGuide = data.style_guide as StyleGuide;

  return {
    id,
    rfpId: data.rfp_id!,
    isPublished: !!data.published_at,
    orgId: data.org_id!,
    participants: data.participants ?? [],
    instructions: data.instructions ?? "",
    styleGuide,
  };
}

export const mergeStyleGuides = (
  a: StyleGuide,
  b: StyleGuide | undefined
): StyleGuide => {
  return mergeObject(a, b);
};

const mergeObject = (
  base: Record<string, any>,
  override: Record<string, any> | undefined
): Record<string, any> => {
  if (!override) {
    return base;
  }

  let merged = JSON.parse(JSON.stringify(base));
  for (const key in override) {
    if (key in base) {
      if (typeof base[key] === "object") {
        merged[key] = mergeObject(base[key], override[key]);
      } else {
        merged[key] = override[key];
      }
    } else {
      merged[key] = override[key];
    }
  }

  return merged;
};
